import * as React from 'react';
import { useState } from 'react';
import MuiMarkdown from 'mui-markdown';
import { Box, Card, CardContent } from '@mui/material';

const MarkdownCard = ({ text: _text, uri, ...props }) => {
    const [text, setText] = useState(null);
    if (uri) {
        fetch(uri).then(r => r.text()).then((t) => setText(t));
    } else {
        setText(_text)
    }

    if (!text) {
        return null;
    }

    return (
        <Card>
            <CardContent>
                <Box>
                    <MuiMarkdown overrides={{
                        p: {
                            component: 'p',
                            props: {
                                style: { lineHeight: 2 },
                            },
                        },
                        ul: {
                            component: 'ul',
                            props: {
                                style: { lineHeight: 2 },
                            },
                        },
                    }}{...props}>{text}</MuiMarkdown>
                </Box>
            </CardContent>
        </Card>
    );
};

export default MarkdownCard;
